import * as React from 'react'
import { Ref, forwardRef } from 'react'

import {
  Box,
  type Dimensions,
  EnhancedDimension,
  useClassNames,
} from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { ViewDimension } from 'modules/shift_management/store/internal/models/View'

import * as stylesRefs from './index.vanilla.css'

interface WrapperCellProps {
  sticky?: boolean
  minWidth: ViewDimension
  padding?: Dimensions | undefined
  noBorder?: boolean
  height?: EnhancedDimension
}

const WrapperCell = (
  {
    children,
    sticky,
    minWidth,
    padding = undefined,
    noBorder = false,
    height = 'full',
  }: React.PropsWithChildren<WrapperCellProps>,
  ref: Ref<HTMLDivElement>
) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      ref={ref}
      height={height}
      background="grey000White"
      // Can't use minWidth prop because s170 as dimension is out of gamma
      style={{ minWidth }}
      flexGrow
      className={cx({ sticky })}
      padding={padding}
      border={
        noBorder
          ? undefined
          : {
              right: {
                width: 's1',
                style: 'solid',
                color: 'grey300',
              },
              bottom: {
                width: 's1',
                style: 'solid',
                color: 'grey300',
              },
            }
      }
    >
      {children}
    </Box>
  )
}

export default observer(forwardRef(WrapperCell))
